import { render, staticRenderFns } from "./CustomerReport.vue?vue&type=template&id=599c35ce"
import script from "./CustomerReport.vue?vue&type=script&lang=js"
export * from "./CustomerReport.vue?vue&type=script&lang=js"
import style0 from "./CustomerReport.vue?vue&type=style&index=0&id=599c35ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports